module.exports = __webpack_public_path__ + "static/media/consequence.1312ba96.svg";